<page-header
    class="tenant-title"
    [pageTitle]="tenantName | uppercase"
    [ngbTooltip]="'Formats.LastUpdateDate' | translate: { date: (tenantLastUpdateDate | dateFormat: 'WithHours2') }"
>
    @if (tenantLogo) {
        <div
            page-header-area="icon"
            class="tenant-logo"
            [style.background-image]="'url(' + tenantLogo + ')'"
        ></div>
    }
</page-header>
<div class="user-actions">
    <multi-search-input
        [groups]="searchGroups()"
        [results]="searchResultsWithMore()"
        (inputChanged)="search($event)"
        (pick)="pickSearchResult($event)"
    />
    <button
        data-testid="OpenNotifications"
        class="btn-notifications btn-badged d-none"
        (click)="toggleNotificationsPanel()"
    >
        <i
            class="far fa-bell"
            ngbTooltip="{{ 'TopBar.Tooltip.Notifications' | translate }}"
            placement="left"
            container="body"
        ></i>
        @if (unreadNotificationsCount$ | async; as unread) {
            <span class="badge badge-pill badge-secondary">{{ unread <= 9 ? unread : '9+' }}</span>
        }
    </button>

	<div ngbDropdown placement="bottom-right">
		<button data-cy="OpenHelp" class="btn-help no-carret" ngbDropdownToggle>
			<i class="far fa-info-circle"></i>
		</button>
		<div class="dropdown-menu" ngbDropdownMenu>
			<button data-cy="OnlineHelp" (click)="openHelp()" class="dropdown-item" translate="TopBar.Tooltip.OnlineHelp"></button>
			<button data-cy="SupportContact" (click)="cpcSupportPhone()" class="dropdown-item" translate="TopBar.Tooltip.Contact"></button>
		</div>
	</div>
    
    @if (hasTranslations) {
        <div data-testid="OpenLanguages" class="user-languages" ngbDropdown placement="bottom-right">
            <button class="btn btn-primary" ngbDropdownToggle data-cy="DropdownToggle">
                {{ currentLanguage | language: true }}
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
                <button (click)="setLanguage(fr)" class="dropdown-item">FR</button>
                <button (click)="setLanguage(en)" class="dropdown-item">EN</button>
            </div>
        </div>
    }
    @if (!!user) {
        <div data-testid="UserAccountMenu" class="user-account" ngbDropdown placement="bottom-right">
            <user-avatar [user]="user" ngbDropdownToggle data-cy="DropdownToggle" class="no-carret"/>

            <div ngbDropdownMenu>
                @if (operator$ | async; as operator) {
                    @if (!operator.isSupport) {
                        <button
                            class="dropdown-item"
                            (click)="editMyInformations()"
                        >
                            <i class="mr-2 fa fa-user"></i>
                            {{ 'TopBar.Account.MyAccount' | translate }}
                        </button>
                    }
                }
                <button class="dropdown-item" (click)="toggleThemesPanel()">
                    <i class="mr-2 far fa-palette"></i>
                    {{ 'App.Themes.Title' | translate }}
                </button>
                <button class="dropdown-item" (click)="leavePlatform()">
                    <i class="mr-2 fa fa-door-open"></i>
                    {{ 'TopBar.Account.Leave' | translate }}
                </button>
                @if (('partnerUrl' | branding)(); as partnershipsUrl) {
                    <a [href]="partnershipsUrl" class="dropdown-item">
                        <i class="mr-2 fa fa-handshake-simple"></i>
                        {{ 'TopBar.Account.Partnerships' | translate }}</a>
                }
                @if (('newsUrl' | branding)(); as newsUrl) {
                    <a [href]="newsUrl" class="dropdown-item">
                        <i class="mr-2 fa fa-newspaper"></i>
                        {{ 'TopBar.Account.News' | translate }}</a>
                }
                <button class="dropdown-item" (click)="userLogout()">
                    <i class="mr-2 fa fa-power-off"></i>
                    {{ 'TopBar.Account.LogOut' | translate }}
                </button>
            </div>
        </div>
    }
</div>
